import { render } from "./FormCadSolicitacaoExame.vue?vue&type=template&id=1d56d6ff&scoped=true"
import script from "./FormCadSolicitacaoExame.vue?vue&type=script&lang=js"
export * from "./FormCadSolicitacaoExame.vue?vue&type=script&lang=js"

import "./FormCadSolicitacaoExame.vue?vue&type=style&index=0&id=1d56d6ff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d56d6ff"]])

export default __exports__